import BrButton from '@govbr/react-components/lib/BrButton';
import { useAppSelector } from '../../../app/hooks';
import avisoIndicativoNascimento from '../../../assets/img/aviso-indicativo-nascimento.svg';
import { selectIntegranteIndicativoNascimento } from '../indicativoNascimentoSlice';
import styles from './IndicativoNascimentoConclusao.module.css';

interface Props {
  onFechar: () => void;
}

const IndicativoNascimentoConclusao: React.FC<Props> = ({ onFechar }) => {
  const integrante = useAppSelector(selectIntegranteIndicativoNascimento);
  const primeiroNome = integrante?.nome?.split(' ')?.[0] ?? '';

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img
          className={styles.imagem}
          src={avisoIndicativoNascimento}
          alt="Cadastro concluído"
        />
      </div>
      <div className={styles.conteudo}>
        <p className={styles.texto}>
          Cadastro concluído!<br />
          {primeiroNome} foi incluído no cadastro da sua família.
        </p>
        <p className={styles.texto}>
          Esse é um passo importante para garantir direitos e cuidados.
        </p>
        <p className={styles.texto}>
          Boas vindas {primeiroNome}!
        </p>
        <div style={{ marginBottom: '32px' }} />
        <BrButton className={styles.botaoFechar} onClick={onFechar}>
          Fechar
        </BrButton>
      </div>
    </div>
  );
};

export default IndicativoNascimentoConclusao;
